/* globals navigator:false */

const userAgent = navigator.userAgent.toLowerCase()

export default {
  isIE: isIE(userAgent),
  isEdge: isEdge(userAgent),
  isFirefox: isFirefox(userAgent),
  isMobile: isMobile(userAgent)
}

function isIE (userAgent) {
  return userAgent.indexOf('msie') > 0 || userAgent.indexOf('trident/') > 0
}

function isEdge (userAgent) {
  return userAgent.indexOf('edge') > 0
}

function isFirefox (userAgent) {
  return userAgent.indexOf('firefox') > 0
}

function isMobile (userAgent) {
  return (/(ip(ad|hone|od)|android)/i).test(userAgent) || (navigator.platform.toLowerCase() === 'macintel' && navigator.maxTouchPoints > 1)
}
